<mat-sidenav-container>
    <mat-sidenav></mat-sidenav>
    <mat-sidenav-content>

        <lomas-public-toolbar></lomas-public-toolbar>

        <section>
            <mat-card>
                <mat-card-title>Bevestiging nieuwsbrief</mat-card-title>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <div class="result">
                        <p *ngIf="status === 'new'">
                            Uw bevestiging wordt verwerkt ...
                        </p>
                        <p *ngIf="status === 'success'">
                            Uw e-mailadres is bevestigd. Kijk ook naar de <a [routerLink]="['/']">gratis proeflessen</a> die we aanbieden.
                        </p>
                        <p *ngIf="status === 'fail'">
                            Het is niet gelukt om e-mailadres te activeren of het e-mailadres is al geactiveerd.
                        </p>
                    </div>
                </mat-card-content>
            </mat-card>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>

